import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/* ─────────────────────────────────────────────
   DADOS DOS EPISÓDIOS - facilmente atualizável
   ───────────────────────────────────────────── */
const episodes = [
  {
    id: 1,
    title: "A Soberania da Atenção",
    guest: "Dr. Jaime Quesado",
    guestBio: "Economista e Gestor",
    guestPhoto: "/assets/podcast/convidados/Jaime.jpg",
    date: "20/07/2026",
    description:
      "Uma reflexão sobre como os sistemas digitais estão a redefinir o poder, a comunicação e a soberania na Europa.\n\nDo papel do Estado à influência das Big Tech, analisamos quem controla a atenção e o impacto disso na economia, na política e na sociedade.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/jaime-quesado-2837a661",
    summary:
      "Neste episódio, Pedro Mendes conversa com Jaime Quesado sobre Inteligência Artificial, atenção humana, inovação, políticas públicas e transformação social. A conversa parte da questão de saber até que ponto a nossa atenção se tornou uma moeda de troca num ecossistema tecnológico mediado por dispositivos, plataformas e sistemas algorítmicos.\n\nJaime Quesado enquadra a IA como uma força central da economia e da sociedade contemporânea, mas sublinha a importância de preservar a criatividade, a consciência e a dimensão humana. A automação é discutida como uma oportunidade de eficiência, mas também como um risco de desumanização dos processos e de exclusão social, sobretudo quando substitui trabalho humano sem criar alternativas de rendimento e participação.\n\nO episódio aborda ainda a transformação das organizações, a dependência de recursos como energia e data centers, e o papel dos intermediários digitais. Na parte final, Jaime Quesado reflete sobre a adaptação das políticas públicas à IA, defendendo que a administração pública deve usar a tecnologia para melhorar serviços e eficiência, mas sem abdicar da intervenção humana.",
    quotes: [
      { timestamp: "00:01", text: "É hoje em dia o nosso olhar, a nossa própria atenção, uma moeda de troca?" },
      { timestamp: "03:08", text: "Até que ponto é que uma sociedade onde as máquinas vão ser cada vez mais chamadas a dar o seu contributo [...] vai conseguir manter a criatividade e a consciência humana?" },
      { timestamp: "05:02", text: "Será possível, numa lógica de valor automático em que a máquina vai ser o grande operador, que as pessoas continuem a ter capacidade de obter rendimentos?" },
      { timestamp: "14:02", text: "Numa altura onde a própria IA é indutora de fake news, a questão da qualidade da informação é muito importante." },
      { timestamp: "17:21", text: "A tecnologia não é um fim em si mesmo [...] é um instrumento, é um operador de eficiência e utilidade." },
    ],
    bioLinks: [
      { timestamp: "01:09", context: "Página biográfica institucional do convidado", url: "https://www.sgeconomia.gov.pt/ciclo-de-wokshops/oradores/jaime-quesado.aspx" },
      { timestamp: "01:09", context: "ISCTE - Perfil com percurso profissional e bibliográfico", url: "https://execed.iscte-iul.pt/docentes/francisco-jaime-quesado-" },
    ],
    sourceLinks: [
      { timestamp: "02:11", context: "António Damásio - A Inteligência Natural: A Lógica da Consciência", url: "https://www.temasedebates.pt/produtos/ficha/a-inteligencia-natural-a-logica-da-consciencia/32040645" },
      { timestamp: "06:36", context: "Yuval Noah Harari - IA, decisão e transformação dos modelos de gestão", url: "https://www.ynharari.com/" },
      { timestamp: "12:09", context: "Daniel Innerarity - Regulação da IA, democracia e accountability", url: "https://en.wikipedia.org/wiki/Daniel_Innerarity" },
      { timestamp: "17:47", context: "George Orwell - Reflexão sobre máquinas, futuro e poder de decisão", url: "https://www.orwellfoundation.com/the-orwell-foundation/orwell/" },
    ],
  },
  {
    id: 2,
    title: "IA e a Gestão de Topo (Parte I)",
    guest: "Dr. Licínio Santos",
    guestBio: "CEO do Montepio Crédito",
    guestInstitutionUrl: { pt: "https://www.bancomontepio.pt/", en: "https://www.bancomontepio.pt/en" },
    guestPhoto: "/assets/podcast/convidados/Licinio.png",
    guestPhotoPosition: "center 20%",
    date: "27/07/2026",
    description:
      "Do percurso pessoal à liderança, uma conversa sobre a construção de uma carreira no setor financeiro, o papel da estratégia e o impacto da tecnologia na evolução do crédito.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/liciniosantos",
    summary:
      "Neste episódio, Pedro Mendes conversa com Licínio Santos, CEO do Montepio Crédito, sobre liderança, carreira, tecnologia, crédito responsável e criação de valor nas organizações. A conversa parte do percurso profissional de Licínio, marcado por mais de duas décadas no sistema financeiro, e aprofunda a forma como a liderança pode mobilizar pessoas, desenvolver equipas e gerar impacto real nas organizações.\n\nAo longo do episódio, Licínio reflete sobre a importância da diversidade de perfis e gerações, defendendo que equipas mais diversas produzem discussões mais ricas e soluções mais completas. A construção de carreira é apresentada como resultado de preparação, empenho e contexto, mais do que de sorte. A conversa aborda também tomada de decisão, cultura de erro e responsabilidade: o objetivo deve ser acertar, corrigir rapidamente quando se falha e evitar a repetição dos mesmos erros.\n\nNa segunda parte, o episódio foca-se no setor do crédito, discutindo o seu papel como ferramenta de gestão orçamental, inclusão social e apoio à concretização de objetivos de famílias e empresas. Licínio apresenta ainda a tecnologia como uma escolha estratégica para escalar operações, sublinhando que o verdadeiro valor continua a ser criado pelas pessoas.",
    quotes: [
      { timestamp: "00:03", text: "Eu não faço parte daquele grupo de emergentes gurus do LinkedIn que dizem: nós temos é que errar." },
      { timestamp: "00:08", text: "Na minha opinião, eu quero é acertar. Acertar é que é bom." },
      { timestamp: "08:03", text: "Eu acredito muito pouco na sorte." },
      { timestamp: "09:38", text: "As pessoas que vencem neste mundo são aquelas que procuram as circunstâncias de que precisam e, quando não as encontram, as criam." },
      { timestamp: "18:45", text: "Aquilo que cria valor são as pessoas, é a sua capacidade de decidir, de pensar, de inovar." },
    ],
    bioLinks: [
      { timestamp: "01:01", context: "Perfil profissional do convidado", url: "https://pt.linkedin.com/in/liciniosantos" },
      { timestamp: "01:04", context: "Montepio Crédito - Instituição central da conversa", url: "https://www.montepiocredito.pt/" },
      { timestamp: "01:04", context: "Montepio Crédito - Órgãos de gestão", url: "https://www.montepiocredito.pt/institucional" },
    ],
    sourceLinks: [
      { timestamp: "09:34", context: "George Bernard Shaw - Prémio Nobel de Literatura (1925)", url: "https://www.nobelprize.org/prizes/literature/1925/shaw/biographical/" },
    ],
  },
  {
    id: 3,
    title: "IA e a Gestão de Topo (Parte II)",
    guest: "Dr. Licínio Santos",
    guestBio: "CEO do Montepio Crédito",
    guestInstitutionUrl: { pt: "https://www.bancomontepio.pt/", en: "https://www.bancomontepio.pt/en" },
    guestPhoto: "/assets/podcast/convidados/Licinio.png",
    guestPhotoPosition: "center 20%",
    date: "03/08/2026",
    description:
      "Uma reflexão sobre o futuro do setor financeiro, onde a inteligência artificial, a personalização e a ética redefinem a forma como decidimos, avaliamos risco e interagimos com o crédito.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/liciniosantos",
    summary:
      "Neste episódio, Pedro Mendes continua a conversa com Licínio Santos, CEO do Montepio Crédito, explorando o impacto da Inteligência Artificial no setor do crédito. A conversa aborda a forma como a IA pode criar valor tanto na eficiência operacional das instituições financeiras como na personalização da experiência do cliente.\n\nLicínio Santos defende que a IA permite automatizar processos, reduzir custos, acelerar decisões e escalar operações, mas o seu verdadeiro potencial está também na capacidade de customizar produtos e adaptar soluções ao perfil de cada cliente. O episódio discute ainda o desafio das instituições financeiras tradicionais perante as fintechs e as novas gerações de consumidores, onde a competitividade passa por conjugar reputação e confiança com jornadas digitais ágeis.\n\nA conversa aprofunda também os limites da IA na tomada de decisão financeira. Licínio sublinha que a tecnologia deve ser vista como suporte à decisão, e não como substituto da responsabilidade humana. Em áreas reguladas como o crédito, é essencial garantir auditabilidade, explicabilidade e ausência de enviesamentos. Na parte final, reflete-se sobre a velocidade da evolução tecnológica e a importância de gestão da mudança, formação contínua, upskilling e reskilling.",
    quotes: [
      { timestamp: "01:41", text: "Do ponto de vista da eficiência é possível automatizar processos, reduzir custos, acelerar a decisão." },
      { timestamp: "05:42", text: "No futuro, vamos ter a capacidade de entregar uma personalização ao mesmo custo de uma standardização." },
      { timestamp: "06:16", text: "Temos que olhar para os modelos de tecnologia e de inteligência artificial numa perspetiva de suporte à decisão e não como substituto da decisão." },
      { timestamp: "11:20", text: "É importante decidir rápido, mas mais do que decidir rápido é importante decidir bem." },
      { timestamp: "16:04", text: "Talvez estejamos a subestimar dois fatores: a velocidade da evolução da tecnologia e o impacto que isso tem nas pessoas e nas organizações." },
    ],
    bioLinks: [
      { timestamp: "00:56", context: "Perfil profissional do convidado", url: "https://pt.linkedin.com/in/liciniosantos" },
      { timestamp: "01:03", context: "Montepio Crédito - IA no setor do crédito", url: "https://www.montepiocredito.pt/" },
      { timestamp: "01:03", context: "Montepio Crédito - Órgãos de gestão", url: "https://www.montepiocredito.pt/institucional" },
      { timestamp: "03:00", context: "Banco Montepio - Reputação e confiança da marca", url: "https://www.bancomontepio.pt/" },
    ],
    sourceLinks: [
      { timestamp: "08:43", context: "EU AI Act - Regulamentação europeia e atividades financeiras de alto risco", url: "https://artificialintelligenceact.eu/" },
    ],
  },
  {
    id: 4,
    title: "Quem Entende o Sistema?",
    guest: "Dr. Filipe Garcia",
    guestBio: "Presidente IMF",
    guestInstitutionUrl: { pt: "https://www.imf.pt/", en: "https://www.imf.pt/en/home-page/" },
    guestPhoto: "/assets/podcast/convidados/Filipe.jpg",
    date: "10/08/2026",
    description:
      "Uma análise sobre literacia financeira, assimetrias de informação e o impacto da inteligência artificial no equilíbrio entre consumidores, instituições e mercado.\n\nNum sistema cada vez mais complexo, discutimos quem está realmente preparado para decidir.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/filipegarcia",
    summary:
      "Pedro Mendes conversa com Filipe Garcia sobre o impacto da Inteligência Artificial na economia, nos mercados financeiros e na relação entre consumidores, instituições financeiras e Estado. A conversa parte da IA enquanto nova revolução tecnológica, comparando-a com transformações anteriores como a Revolução Industrial, a internet e a digitalização.\n\nFilipe Garcia defende que a IA pode melhorar o nível médio de vida e criar novas oportunidades, mas alerta que isso não significa necessariamente uma redução das desigualdades. No setor financeiro, o episódio explora como a IA pode ajudar consumidores a analisar contratos, comparar propostas, avaliar riscos e tomar decisões mais informadas. No entanto, evidencia também a assimetria entre clientes e instituições financeiras, uma vez que estas últimas controlam o desenho dos produtos, têm maior capacidade técnica e podem usar dados comportamentais para otimizar os seus próprios interesses.\n\nA conversa aborda ainda a importância da literacia financeira, os riscos associados à concentração de poder tecnológico e o crescimento de fraudes financeiras, roubo de identidade, deepfakes e impersonation. Filipe Garcia defende que a tecnologia é neutra, mas o seu impacto depende de quem a controla e de como é utilizada.",
    quotes: [
      { timestamp: "00:00", text: "Todos aqueles que tiverem acesso a bons modelos e os souberem utilizar vão sair vencedores." },
      { timestamp: "07:15", text: "É um tipo de ferramenta que estará sempre mais tendente a aumentar a desigualdade do que a diminuí-la." },
      { timestamp: "16:22", text: "A digitalização traz facilidade, mas também traz facilitismo." },
      { timestamp: "23:36", text: "A educação é o que nos dá graus de liberdade." },
      { timestamp: "39:33", text: "A tecnologia em si mesma é neutra." },
    ],
    bioLinks: [
      { timestamp: "00:58", context: "Perfil académico e profissional do convidado", url: "https://www.pea.iscap.ipp.pt/docentes/filipe-garcia" },
      { timestamp: "02:04", context: "APAF - Associação Portuguesa de Analistas Financeiros", url: "https://www.apaf.org.pt/" },
      { timestamp: "02:11", context: "Ordem dos Economistas - Colégio de Análise Financeira", url: "https://www.ordemeconomistas.pt/" },
    ],
    sourceLinks: [
      { timestamp: "18:00", context: "Literacia Financeira - Banco de Portugal (2023)", url: "https://clientebancario.bportugal.pt/pt-pt/publicacao/relatorio-do-inquerito-literacia-financeira-da-populacao-portuguesa-2023" },
      { timestamp: "18:00", context: "OCDE - Educação Financeira", url: "https://www.oecd.org/financial/education/" },
      { timestamp: "20:32", context: "Banco de Portugal - Supervisão financeira", url: "https://www.bportugal.pt/" },
      { timestamp: "20:36", context: "CMVM - Supervisão dos mercados financeiros", url: "https://www.cmvm.pt/" },
      { timestamp: "20:36", context: "Autoridade da Concorrência", url: "https://www.concorrencia.pt/" },
    ],
  },
  {
    id: 5,
    titleIsEnglish: true,
    title: "The BlackBox",
    guest: "Prof. Luís Paulo Reis",
    guestBio: "Diretor Laboratório de IA. da UP",
    guestInstitutionUrl: { pt: "https://liacc.fe.up.pt/", en: "https://liacc.fe.up.pt/" },
    guestPhoto: "/assets/podcast/convidados/LPR.jpg",
    date: "17/08/2026",
    description:
      "Uma exploração sobre a evolução da inteligência artificial, dos sistemas que aprendem sozinhos aos riscos de segurança e perda de controlo.\n\nDa fraude digital à singularidade, analisamos até onde a IA pode ir e o que isso significa para empresas, sociedade e futuro do trabalho e educação.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/lpreis",
    summary:
      "Neste episódio, Pedro Mendes conversa com o Professor Luís Paulo Reis sobre a evolução da Inteligência Artificial, desde os sistemas simbólicos e o machine learning até à IA generativa, aos agentes autónomos e à robótica inteligente. A conversa oferece uma perspetiva técnica, académica e aplicada sobre o estado atual da tecnologia e os seus impactos sociais.\n\nLuís Paulo Reis explica que a IA evoluiu para sistemas capazes de aprender a partir de grandes volumes de dados, identificar padrões complexos e resolver problemas de forma autónoma. Exemplos como AlphaGo e AlphaGo Zero mostram que algumas soluções produzidas por máquinas podem ultrapassar a compreensão humana direta, criando novas formas de resolver problemas. O episódio aborda também os riscos de deepfakes e a facilidade com que voz, imagem e texto podem ser gerados ou manipulados.\n\nA conversa explora o impacto da IA em áreas como programação, jornalismo, direito, agricultura, energia e educação. Na parte final, o episódio aprofunda a robótica, o deep reinforcement learning e os dilemas éticos da autonomia das máquinas. Luís Paulo Reis defende que a educação terá de mudar, colocando maior foco no pensamento crítico, na formulação de problemas e na avaliação do processo de aprendizagem.",
    quotes: [
      { timestamp: "00:00", text: "Neste momento eu já não programo, porque o computador já programa melhor do que eu." },
      { timestamp: "04:25", text: "Esta nova Inteligência Artificial eventualmente pode nem sequer estar ao alcance da nossa compreensão de como é que ela funciona." },
      { timestamp: "05:23", text: "Eu vejo muito a inteligência como a capacidade de resolver novos problemas através de uma utilização habilidosa do conhecimento." },
      { timestamp: "08:48", text: "É impossível não investigarmos em IA porque a IA pode ter consequências más." },
      { timestamp: "37:22", text: "Criar esta nova geração de robôs que vão começar a espalhar-se pelas nossas casas, a fazer tarefas domésticas e a aprender connosco. O futuro é já." },
    ],
    bioLinks: [
      { timestamp: "00:57", context: "Perfil do convidado na FEUP", url: "https://sigarra.up.pt/feup/pt/func_geral.formview?p_codigo=211669" },
      { timestamp: "01:17", context: "FEUP - Faculdade de Engenharia da Universidade do Porto", url: "https://sigarra.up.pt/feup/pt/web_page.inicial" },
      { timestamp: "01:20", context: "LIACC - Laboratório de IA e Ciência de Computadores", url: "https://liacc.fe.up.pt/member/lpr" },
      { timestamp: "36:14", context: "Google Scholar - Publicações científicas do convidado", url: "https://scholar.google.com/citations?user=bCKD3moAAAAJ" },
      { timestamp: "36:14", context: "CienciaVitae - Perfil académico e afiliações", url: "https://www.cienciavitae.pt/1111-43FF-1F99" },
    ],
    sourceLinks: [
      { timestamp: "03:34", context: "AlphaGo - DeepMind (aprendizagem automática)", url: "https://deepmind.google/research/breakthroughs/alphago/" },
      { timestamp: "07:48", context: "EU AI Act - Regulação europeia da IA", url: "https://artificialintelligenceact.eu/" },
      { timestamp: "14:20", context: "UAE AI Strategy - Estratégia nacional de IA dos Emirados Árabes", url: "https://ai.gov.ae/" },
      { timestamp: "26:18", context: "Moral Machine (MIT) - Dilemas éticos dos carros autónomos", url: "https://www.moralmachine.net/" },
      { timestamp: "30:34", context: "FEUP - Curso de IA referido pelo convidado", url: "https://sigarra.up.pt/feup/pt/cur_geral.cur_view?pv_curso_id=23521" },
      { timestamp: "37:56", context: "Unitree Robotics - Robótica avançada referenciada no episódio", url: "https://www.unitree.com/" },
    ],
  },
  {
    id: 6,
    title: "A Algoritmização da Liberdade",
    guest: "Prof. Ricardo Valente",
    guestBio: "Especialista em Políticas Públicas",
    guestPhoto: "/assets/podcast/convidados/Ricardo.jpeg",
    date: "24/08/2026",
    description:
      "Uma análise sobre como os sistemas digitais estão a transformar o mercado, a informação e a autonomia individual.\n\nDa influência das Big Tech à posição da Europa, discutimos o impacto dos algoritmos na competitividade, na decisão e na liberdade económica.",
    links: {
      youtube: "",
      spotify: "",
      apple: "",
    },
    resources: [],
    linkedin: "https://pt.linkedin.com/in/ricardo-valente-3477885",
    summary:
      "Neste episódio, Pedro Mendes conversa com Ricardo Valente sobre Inteligência Artificial, smart cities, soberania dos dados, digitalização, geopolítica e transformação social. A conversa começa pela relação entre cidade, informação e cidadão, refletindo sobre o que significa ser uma smart city num contexto em que os dados são cada vez mais importantes para a gestão urbana.\n\nRicardo Valente defende que a tecnologia só cria valor quando está alinhada com estratégia, visão e processos bem estruturados. A digitalização, por si só, não resolve problemas: se os processos continuarem mal desenhados, a tecnologia apenas os reproduz em formato digital. Ricardo alerta também para a tendência das respostas únicas reduzirem o sentido crítico e para o facto de a IA funcionar sobre dados cuja origem, intenção e propriedade nem sempre são transparentes.\n\nNa parte final, o episódio aborda a IA como questão geopolítica, discutindo a soberania europeia, o AI Act, o RGPD e a necessidade de adaptação das políticas públicas. O episódio termina com uma ideia central: a revolução da IA distingue-se das anteriores sobretudo pela sua velocidade, o que torna mais difícil acompanhar, regular e adaptar a sociedade às mudanças em curso.",
    quotes: [
      { timestamp: "07:38", text: "Não adianta nada digitalizar um processo estúpido. Passas a ter um estúpido digital." },
      { timestamp: "10:16", text: "Estamos tão próximos de 1984, de George Orwell e o grande Big Brother." },
      { timestamp: "11:10", text: "Nós gostamos, muitas vezes, de estar completamente errados com base na certeza." },
      { timestamp: "15:49", text: "O nosso valor está nela. É a informação proprietária." },
      { timestamp: "30:21", text: "O grande problema da revolução da IA não é nós termos uma revolução, é a velocidade da revolução." },
    ],
    bioLinks: [
      { timestamp: "00:45", context: "Perfil na Faculdade de Economia da Universidade do Porto", url: "https://sigarra.up.pt/fep/pt/func_geral.formview?p_codigo=235980" },
      { timestamp: "00:45", context: "PBS - Porto Business School", url: "https://www.pbs.up.pt/sobre-nos/corpo-docente/docente/ricardo-valente/" },
    ],
    sourceLinks: [
      { timestamp: "10:16", context: "George Orwell - Nineteen Eighty-Four", url: "https://www.orwellfoundation.com/the-orwell-foundation/orwell/books-by-orwell/nineteen-eighty-four/" },
      { timestamp: "25:32", context: "Palantir - Soberania tecnológica e segurança estratégica", url: "https://www.palantir.com/" },
      { timestamp: "27:05", context: "EU AI Act - Regulação europeia da Inteligência Artificial", url: "https://artificialintelligenceact.eu/" },
      { timestamp: "27:08", context: "RGPD - Proteção de dados na União Europeia", url: "https://commission.europa.eu/law/law-topic/data-protection/data-protection-eu_en" },
    ],
  },
];

const podcastYoutubeUrl = "https://youtube.com/@brands-channel?si=gDnXRjT2wO7UXIY6";
const podcastSpotifyUrl = "https://open.spotify.com/show/64cbc4Kt8G4EbXvERg1dgk";
const podcastAppleUrl = "https://podcasts.apple.com/us/podcast/empower-brands-channel/id1625679465";
const hostLinkedinUrl = "https://pt.linkedin.com/in/pmcmendes";

const SUPPORTED_LANGS = ["pt", "en", "es"];

const PODCAST_COPY = {
  pt: {
    backLabel: "Voltar",
    heroDescription:
      "Exploramos o impacto invisível da tecnologia na sociedade contemporânea. Conversas com especialistas em IA, economia, inovação e política pública.",
    youtubeLabel: "YouTube",
    spotifyLabel: "Spotify",
    appleLabel: "Apple Podcasts",
    scrollLabel: "Explorar",
    scrollAria: "Scroll para explorar",
    eyebrow: "Podcast",
    aboutTitlePrefix: "Sobre o ",
    aboutTitleHighlight: "Invisible Side",
    aboutParagraph1:
      "Invisible Side explora o impacto invisível da tecnologia na sociedade contemporânea. Através de conversas com especialistas em inteligência artificial, economia, inovação e política pública, analisamos como os sistemas digitais estão a redefinir a atenção, a decisão e o poder.",
    aboutParagraph2:
      "Num mundo mediado por algoritmos, este podcast procura questionar quem controla a informação e quais as implicações dessa transformação para o futuro.",
    localeLabel: "Português de Portugal",
    categoryLabel: "Tecnologia",
    hostCategory: "Apresentador",
    hostRole: "Empresário & Especialista em Soluções Digitais",
    hostBio:
      "Atua na interseção entre tecnologia e comunicação, focando-se na forma como os sistemas digitais moldam a relação entre organizações e pessoas.",
    hostLinkedin: "LinkedIn",
    videoEssayTitle: "Sobre o Videocast",
    articleLink: "Artigo de Opinião",
    articleTitle: "A Morte da Neutralidade do Dispositivo",
    articleQuote: "\"Tudo compete pela atenção. O dispositivo decide o que chega até nós.\"",
    articleCards: [
      {
        title: "Soberania da Atenção",
        body: "Com quem se negoceia a visibilidade quando os canais de distribuição são proprietários e opacos?",
      },
      {
        title: "Vazio de Regulação",
        body: "Quem arbitra os critérios destes intermediários que controlam o fluxo da informação?",
      },
      {
        title: "O Futuro das PMEs",
        body: "Haverá margem para empresas tecnológicas que não são donas do seu próprio \"tubo\" de comunicação?",
      },
      {
        title: "Cenário 2030",
        body: "A transição da relação direta para a \"intermediação total\" gerida por agentes de IA.",
      },
    ],
    episodesTitle: "Episódios",
    episodesSubtitle: "Seleciona um episódio para saber mais",
    episodeLabel: "Ep.",
    previousEpisode: "Episódio anterior",
    nextEpisode: "Próximo episódio",
    mentionedResources: "Recursos mencionados",
    allEpisodesTitle: "Todos os Episódios",
    footerTitle: "Invisible Side Videocast",
    abstractLabel: "Abstract: O Labirinto da Intermediação – A Organização perante a Infraestrutura da Atenção",
    abstractParagraphs: [
      "No ecossistema atual, a comunicação entre organizações e cidadãos deixou de ser direta. Cada tentativa de contacto é filtrada por múltiplas camadas: sistemas operativos, algoritmos e infraestruturas de IA, que hoje atuam como os novos \"porteiros\" da realidade digital.",
      "Neste debate, exploramos o espaço legítimo de contacto: como podem instituições como o Estado, a Banca ou os Media manter a sua autonomia quando as regras de acesso ao utilizador são ditadas por um oligopólio global?",
    ],
    expandLabel: "Ver detalhes do episódio",
    collapseLabel: "Ocultar notas",
    notesLabel: "Resumo",
    quotesLabel: "Frases marcantes",
    bioLinksLabel: "Convidado & instituições",
    sourceLinksLabel: "Fontes & referências",
  },
  en: {
    backLabel: "Back",
    heroDescription:
      "We explore the invisible impact of technology on contemporary society. Conversations with experts in AI, economics, innovation and public policy.",
    youtubeLabel: "YouTube",
    spotifyLabel: "Spotify",
    appleLabel: "Apple Podcasts",
    scrollLabel: "Explore",
    scrollAria: "Scroll to explore",
    eyebrow: "Podcast",
    aboutTitlePrefix: "About ",
    aboutTitleHighlight: "Invisible Side",
    aboutParagraph1:
      "Invisible Side explores the invisible impact of technology on contemporary society. Through conversations with experts in artificial intelligence, economics, innovation and public policy, we examine how digital systems are reshaping attention, decision-making and power.",
    aboutParagraph2:
      "In a world mediated by algorithms, this podcast questions who controls information and what the implications of that transformation are for the future.",
    localeLabel: "English",
    categoryLabel: "Technology",
    hostCategory: "Presenter",
    hostRole: "Entrepreneur & Digital Solutions Specialist",
    hostBio:
      "He works at the intersection of technology and communication, focusing on how digital systems shape the relationship between organizations and people.",
    hostLinkedin: "LinkedIn",
    videoEssayTitle: "About the Videocast",
    articleLink: "Opinion Article",
    articleTitle: "The Death of Device Neutrality",
    articleQuote: "\"Everything competes for attention. The device decides what reaches us.\"",
    articleCards: [
      {
        title: "Attention Sovereignty",
        body: "Who negotiates visibility when distribution channels are proprietary and opaque?",
      },
      {
        title: "Regulatory Void",
        body: "Who arbitrates the criteria of these intermediaries that control the flow of information?",
      },
      {
        title: "The Future of SMEs",
        body: "Will there be room for technology companies that do not own their own communication pipeline?",
      },
      {
        title: "2030 Scenario",
        body: "The transition from direct relationships to total intermediation managed by AI agents.",
      },
    ],
    episodesTitle: "Episodes",
    episodesSubtitle: "Select an episode to learn more",
    episodeLabel: "Ep.",
    previousEpisode: "Previous episode",
    nextEpisode: "Next episode",
    mentionedResources: "Mentioned resources",
    allEpisodesTitle: "All Episodes",
    footerTitle: "Invisible Side Videocast",
    abstractLabel: "Abstract: The Labyrinth of Intermediation – The Organization Facing the Infrastructure of Attention",
    abstractParagraphs: [
      "In today's ecosystem, communication between organizations and citizens is no longer direct. Every attempt at contact is filtered through multiple layers: operating systems, algorithms and AI infrastructures, which now act as the new gatekeepers of digital reality.",
      "In this discussion, we explore the legitimate space for contact: how can institutions such as the State, Banking or the Media maintain their autonomy when the rules of access to the user are dictated by a global oligopoly?",
    ],
    expandLabel: "View episode notes",
    collapseLabel: "Hide notes",
    notesLabel: "Summary",
    quotesLabel: "Key quotes",
    bioLinksLabel: "Guest & institutions",
    sourceLinksLabel: "Sources & references",
  },
  es: {
    backLabel: "Volver",
    heroDescription:
      "Exploramos el impacto invisible de la tecnología en la sociedad contemporánea. Conversaciones con especialistas en IA, economía, innovación y política pública.",
    youtubeLabel: "YouTube",
    spotifyLabel: "Spotify",
    appleLabel: "Apple Podcasts",
    scrollLabel: "Explorar",
    scrollAria: "Desplázate para explorar",
    eyebrow: "Podcast",
    aboutTitlePrefix: "Sobre ",
    aboutTitleHighlight: "Invisible Side",
    aboutParagraph1:
      "Invisible Side explora el impacto invisible de la tecnología en la sociedad contemporánea. A través de conversaciones con especialistas en inteligencia artificial, economía, innovación y política pública, analizamos cómo los sistemas digitales están redefiniendo la atención, la decisión y el poder.",
    aboutParagraph2:
      "En un mundo mediado por algoritmos, este podcast cuestiona quién controla la información y cuáles son las implicaciones de esa transformación para el futuro.",
    localeLabel: "Español",
    categoryLabel: "Tecnología",
    hostCategory: "Presentador",
    hostRole: "Empresario y Especialista en Soluciones Digitales",
    hostBio:
      "Trabaja en la intersección entre tecnología y comunicación, centrándose en cómo los sistemas digitales moldean la relación entre organizaciones y personas.",
    hostLinkedin: "LinkedIn",
    videoEssayTitle: "Sobre el Videocast",
    articleLink: "Artículo de Opinión",
    articleTitle: "La Muerte de la Neutralidad del Dispositivo",
    articleQuote: "\"Todo compite por la atención. El dispositivo decide lo que nos llega.\"",
    articleCards: [
      {
        title: "Soberanía de la Atención",
        body: "¿Con quién se negocia la visibilidad cuando los canales de distribución son propietarios y opacos?",
      },
      {
        title: "Vacío Regulatorio",
        body: "¿Quién arbitra los criterios de estos intermediarios que controlan el flujo de información?",
      },
      {
        title: "El Futuro de las PYMES",
        body: "¿Habrá espacio para empresas tecnológicas que no sean dueñas de su propio canal de comunicación?",
      },
      {
        title: "Escenario 2030",
        body: "La transición de la relación directa a la intermediatización total gestionada por agentes de IA.",
      },
    ],
    episodesTitle: "Episodios",
    episodesSubtitle: "Selecciona un episodio para saber más",
    episodeLabel: "Ep.",
    previousEpisode: "Episodio anterior",
    nextEpisode: "Siguiente episodio",
    mentionedResources: "Recursos mencionados",
    allEpisodesTitle: "Todos los Episodios",
    footerTitle: "Invisible Side Videocast",
    abstractLabel: "Abstract: El Laberinto de la Intermediación – La Organización ante la Infraestructura de la Atención",
    abstractParagraphs: [
      "En el ecosistema actual, la comunicación entre organizaciones y ciudadanos ya no es directa. Cada intento de contacto pasa por múltiples capas: sistemas operativos, algoritmos e infraestructuras de IA, que hoy actúan como los nuevos porteros de la realidad digital.",
      "En este debate exploramos el espacio legítimo de contacto: ¿cómo pueden instituciones como el Estado, la banca o los medios mantener su autonomía cuando las reglas de acceso al usuario están dictadas por un oligopolio global?",
    ],
    expandLabel: "Ver notas del episodio",
    collapseLabel: "Ocultar notas",
    notesLabel: "Resumen",
    quotesLabel: "Frases destacadas",
    bioLinksLabel: "Invitado e instituciones",
    sourceLinksLabel: "Fuentes y referencias",
  },
};

const EPISODE_TRANSLATIONS = {
  1: {
    en: {
      title: "Attention Sovereignty",
      guestBio: "Economist and Manager",
      description:
        "A reflection on how digital systems are redefining power, communication and sovereignty in Europe.\n\nFrom the role of the State to the influence of Big Tech, we analyse who controls attention and the impact this has on the economy, politics and society.",
      summary:
        "In this episode, Pedro Mendes speaks with Jaime Quesado about Artificial Intelligence, human attention, innovation, public policies and social transformation. The conversation begins by asking to what extent our attention has become a bargaining chip within a technological ecosystem mediated by devices, platforms and algorithmic systems.\n\nJaime Quesado frames AI as a central force in the contemporary economy and society, but stresses the importance of preserving creativity, consciousness and the human dimension. Automation is discussed as an opportunity for efficiency, but also as a risk of dehumanizing processes and social exclusion, especially when it replaces human work without creating alternatives for income and participation.\n\nThe episode also addresses organizational transformation, the dependence on resources such as energy and data centres, and the role of digital intermediaries. In the final part, Jaime Quesado reflects on the adaptation of public policies to AI, arguing that public administration should use technology to improve services and efficiency, without giving up human intervention.",
      quotes: [
        { timestamp: "00:01", text: "Is our gaze, our very attention, a bargaining chip today?" },
        { timestamp: "03:08", text: "To what extent will a society where machines are increasingly called upon to contribute [...] be able to maintain human creativity and consciousness?" },
        { timestamp: "05:02", text: "Will it be possible, in an automated value logic where the machine will be the great operator, for people to continue earning income?" },
        { timestamp: "14:02", text: "At a time when AI itself induces fake news, the quality of information is a very important issue." },
        { timestamp: "17:21", text: "Technology is not an end in itself [...] it is an instrument, an operator of efficiency and utility." },
      ],
      bioLinks: [
        { timestamp: "01:09", context: "Guest's institutional biographical page", url: "https://www.sgeconomia.gov.pt/ciclo-de-wokshops/oradores/jaime-quesado.aspx" },
        { timestamp: "01:09", context: "ISCTE - Professional and bibliographic profile", url: "https://execed.iscte-iul.pt/docentes/francisco-jaime-quesado-" },
      ],
      sourceLinks: [
        { timestamp: "02:11", context: "António Damásio - Natural Intelligence: The Logic of Consciousness", url: "https://www.temasedebates.pt/produtos/ficha/a-inteligencia-natural-a-logica-da-consciencia/32040645" },
        { timestamp: "06:36", context: "Yuval Noah Harari - AI, decision-making and management model transformation", url: "https://www.ynharari.com/" },
        { timestamp: "12:09", context: "Daniel Innerarity - AI regulation, democracy and accountability", url: "https://en.wikipedia.org/wiki/Daniel_Innerarity" },
        { timestamp: "17:47", context: "George Orwell - Reflection on machines, the future and decision-making power", url: "https://www.orwellfoundation.com/the-orwell-foundation/orwell/" },
      ],
    },
    es: {
      title: "La Soberanía de la Atención",
      guestBio: "Economista y Gestor",
      description:
        "Una reflexión sobre cómo los sistemas digitales están redefiniendo el poder, la comunicación y la soberanía en Europa.\n\nDesde el papel del Estado hasta la influencia de las Big Tech, analizamos quién controla la atención y el impacto que esto tiene en la economía, la política y la sociedad.",
    },
  },
  2: {
    en: {
      title: "Agentic Innovation in the C-Suite (Part I)",
      guestBio: "CEO of Montepio Crédito",
      description:
        "From personal journey to leadership, a conversation about building a career in the financial sector, the role of strategy and the impact of technology on the evolution of credit.",
      summary:
        "In this episode, Pedro Mendes speaks with Licínio Santos, CEO of Montepio Crédito, about leadership, career, technology, responsible credit and value creation in organizations. The conversation begins with Licínio's professional path, marked by more than two decades in the financial system, and delves into how leadership can mobilize people, develop teams and generate real impact in organizations.\n\nThroughout the episode, Licínio reflects on the importance of diversity of profiles and generations, arguing that more diverse teams produce richer discussions and more complete solutions. Career building is presented as a result of preparation, commitment and context, rather than luck. The conversation also covers decision-making, a culture of error and responsibility: the goal should be to get it right, to correct quickly when mistakes happen and to avoid repeating the same errors.\n\nIn the second part, the episode focuses on the credit sector, discussing its role as a budget management tool, social inclusion and support for achieving the goals of families and businesses. Licínio also presents technology as a strategic choice for scaling operations, stressing that true value continues to be created by people.",
      quotes: [
        { timestamp: "00:03", text: "I'm not part of that group of emerging LinkedIn gurus who say: we just have to fail." },
        { timestamp: "00:08", text: "In my opinion, I want to get it right. Getting it right is what's good." },
        { timestamp: "08:03", text: "I believe very little in luck." },
        { timestamp: "09:38", text: "The people who succeed in this world are those who seek the circumstances they need and, when they don't find them, create them." },
        { timestamp: "18:45", text: "What creates value is people, their ability to decide, to think, to innovate." },
      ],
      bioLinks: [
        { timestamp: "01:01", context: "Guest's professional profile", url: "https://pt.linkedin.com/in/liciniosantos" },
        { timestamp: "01:04", context: "Montepio Crédito - Central institution of the conversation", url: "https://www.montepiocredito.pt/" },
        { timestamp: "01:04", context: "Montepio Crédito - Management board", url: "https://www.montepiocredito.pt/institucional" },
      ],
      sourceLinks: [
        { timestamp: "09:34", context: "George Bernard Shaw - Nobel Prize in Literature (1925)", url: "https://www.nobelprize.org/prizes/literature/1925/shaw/biographical/" },
      ],
    },
    es: {
      title: "IA y la Alta Dirección (Parte I)",
      guestBio: "CEO de Montepio Crédito",
      description:
        "Del recorrido personal al liderazgo, una conversación sobre la construcción de una carrera en el sector financiero, el papel de la estrategia y el impacto de la tecnología en la evolución del crédito.",
    },
  },
  3: {
    en: {
      title: "Agentic Innovation in the C-Suite (Part II)",
      guestBio: "CEO of Montepio Crédito",
      description:
        "A reflection on the future of the financial sector, where artificial intelligence, personalization and ethics are redefining the way we decide, assess risk and interact with credit.",
      summary:
        "In this episode, Pedro Mendes continues the conversation with Licínio Santos, CEO of Montepio Crédito, exploring the impact of Artificial Intelligence on the credit sector. The conversation addresses how AI can create value both in the operational efficiency of financial institutions and in personalizing the customer experience.\n\nLicínio Santos argues that AI enables process automation, cost reduction, faster decision-making and scaling of operations, but its true potential also lies in its ability to customize products and adapt solutions to each client's profile. The episode also discusses the challenge facing traditional financial institutions in the face of fintechs and new generations of consumers, where competitiveness depends on combining reputation and trust with agile digital journeys.\n\nThe conversation also explores the limits of AI in financial decision-making. Licínio stresses that technology should be seen as decision support, not as a substitute for human responsibility. In regulated areas such as credit, it is essential to ensure auditability, explainability and the absence of bias. In the final part, the discussion reflects on the speed of technological evolution and the importance of change management, continuous training, upskilling and reskilling.",
      quotes: [
        { timestamp: "01:41", text: "From an efficiency standpoint, it is possible to automate processes, reduce costs and accelerate decision-making." },
        { timestamp: "05:42", text: "In the future, we will have the ability to deliver personalization at the same cost as standardization." },
        { timestamp: "06:16", text: "We have to look at technology and artificial intelligence models from a decision-support perspective, not as a substitute for the decision." },
        { timestamp: "11:20", text: "It's important to decide quickly, but more important than deciding quickly is deciding well." },
        { timestamp: "16:04", text: "Perhaps we are underestimating two factors: the speed of technological evolution and the impact it has on people and organizations." },
      ],
      bioLinks: [
        { timestamp: "00:56", context: "Guest's professional profile", url: "https://pt.linkedin.com/in/liciniosantos" },
        { timestamp: "01:03", context: "Montepio Crédito - AI in the credit sector", url: "https://www.montepiocredito.pt/" },
        { timestamp: "01:03", context: "Montepio Crédito - Management board", url: "https://www.montepiocredito.pt/institucional" },
        { timestamp: "03:00", context: "Banco Montepio - Brand reputation and trust", url: "https://www.bancomontepio.pt/en" },
      ],
      sourceLinks: [
        { timestamp: "08:43", context: "EU AI Act - European regulation and high-risk financial activities", url: "https://artificialintelligenceact.eu/" },
      ],
    },
    es: {
      title: "IA y la Alta Dirección (Parte II)",
      guestBio: "CEO de Montepio Crédito",
      description:
        "Una reflexión sobre el futuro del sector financiero, donde la inteligencia artificial, la personalización y la ética están redefiniendo la forma en que decidimos, evaluamos el riesgo e interactuamos con el crédito.",
    },
  },
  4: {
    en: {
      title: "Maintaining a Grip on the System",
      guestBio: "IMF President",
      description:
        "An analysis of financial literacy, information asymmetries and the impact of artificial intelligence on the balance between consumers, institutions and the market.\n\nIn an increasingly complex system, we discuss who is truly prepared to decide.",
      summary:
        "Pedro Mendes speaks with Filipe Garcia about the impact of Artificial Intelligence on the economy, financial markets and the relationship between consumers, financial institutions and the State. The conversation starts from AI as a new technological revolution, comparing it with previous transformations such as the Industrial Revolution, the internet and digitalization.\n\nFilipe Garcia argues that AI can improve the average standard of living and create new opportunities, but warns that this does not necessarily mean a reduction in inequalities. In the financial sector, the episode explores how AI can help consumers analyse contracts, compare proposals, assess risks and make more informed decisions. However, it also highlights the asymmetry between clients and financial institutions, since the latter control product design, have greater technical capacity and can use behavioural data to optimize their own interests.\n\nThe conversation also addresses the importance of financial literacy, the risks associated with the concentration of technological power and the growth of financial fraud, identity theft, deepfakes and impersonation. Filipe Garcia argues that technology is neutral, but its impact depends on who controls it and how it is used.",
      quotes: [
        { timestamp: "00:00", text: "All those who have access to good models and know how to use them will come out as winners." },
        { timestamp: "07:15", text: "It is a type of tool that will always tend more to increase inequality than to reduce it." },
        { timestamp: "16:22", text: "Digitalization brings ease, but it also brings complacency." },
        { timestamp: "23:36", text: "Education is what gives us degrees of freedom." },
        { timestamp: "39:33", text: "Technology in itself is neutral." },
      ],
      bioLinks: [
        { timestamp: "00:58", context: "Guest's academic and professional profile", url: "https://www.pea.iscap.ipp.pt/docentes/filipe-garcia" },
        { timestamp: "02:04", context: "APAF - Portuguese Association of Financial Analysts", url: "https://www.apaf.org.pt/" },
        { timestamp: "02:11", context: "Order of Economists - Financial Analysis College", url: "https://www.ordemeconomistas.pt/" },
      ],
      sourceLinks: [
        { timestamp: "18:00", context: "Financial Literacy - Bank of Portugal (2023)", url: "https://clientebancario.bportugal.pt/pt-pt/publicacao/relatorio-do-inquerito-literacia-financeira-da-populacao-portuguesa-2023" },
        { timestamp: "18:00", context: "OECD - Financial Education", url: "https://www.oecd.org/financial/education/" },
        { timestamp: "20:32", context: "Bank of Portugal - Financial supervision", url: "https://www.bportugal.pt/" },
        { timestamp: "20:36", context: "CMVM - Financial markets supervision", url: "https://www.cmvm.pt/" },
        { timestamp: "20:36", context: "Competition Authority", url: "https://www.concorrencia.pt/" },
      ],
    },
    es: {
      title: "¿Quién Entiende el Sistema?",
      guestBio: "Presidente del IMF",
      description:
        "Un análisis sobre alfabetización financiera, asimetrías de información y el impacto de la inteligencia artificial en el equilibrio entre consumidores, instituciones y mercado.\n\nEn un sistema cada vez más complejo, debatimos quién está realmente preparado para decidir.",
    },
  },
  5: {
    en: {
      title: "The BlackBox",
      titleIsEnglish: true,
      guestBio: "Director of UP's AI Laboratory",
      description:
        "An exploration of the evolution of artificial intelligence, from self-learning systems to the risks of security and loss of control.\n\nFrom digital fraud to singularity, we analyse how far AI can go and what that means for companies, society and the future of work and education.",
      summary:
        "In this episode, Pedro Mendes speaks with Professor Luís Paulo Reis about the evolution of Artificial Intelligence, from symbolic systems and machine learning to generative AI, autonomous agents and intelligent robotics. The conversation offers a technical, academic and applied perspective on the current state of technology and its social impacts.\n\nLuís Paulo Reis explains that AI has evolved into systems capable of learning from large volumes of data, identifying complex patterns and solving problems autonomously. Examples such as AlphaGo and AlphaGo Zero show that some solutions produced by machines can surpass direct human understanding, creating new ways of solving problems. The episode also addresses the risks of deepfakes and the ease with which voice, image and text can be generated or manipulated.\n\nThe conversation explores the impact of AI in areas such as programming, journalism, law, agriculture, energy and education. In the final part, the episode delves into robotics, deep reinforcement learning and the ethical dilemmas of machine autonomy. Luís Paulo Reis argues that education will have to change, placing greater emphasis on critical thinking, problem formulation and the assessment of the learning process.",
      quotes: [
        { timestamp: "00:00", text: "At this point I no longer program, because the computer already programs better than I do." },
        { timestamp: "04:25", text: "This new Artificial Intelligence may not even be within our understanding of how it works." },
        { timestamp: "05:23", text: "I see intelligence very much as the ability to solve new problems through a skilful use of knowledge." },
        { timestamp: "08:48", text: "It is impossible not to research AI because AI can have bad consequences." },
        { timestamp: "37:22", text: "Creating this new generation of robots that will start spreading through our homes, doing domestic tasks and learning with us. The future is now." },
      ],
      bioLinks: [
        { timestamp: "00:57", context: "Guest's profile at FEUP", url: "https://sigarra.up.pt/feup/pt/func_geral.formview?p_codigo=211669" },
        { timestamp: "01:17", context: "FEUP - Faculty of Engineering, University of Porto", url: "https://sigarra.up.pt/feup/pt/web_page.inicial" },
        { timestamp: "01:20", context: "LIACC - AI and Computer Science Laboratory", url: "https://liacc.fe.up.pt/member/lpr" },
        { timestamp: "36:14", context: "Google Scholar - Guest's scientific publications", url: "https://scholar.google.com/citations?user=bCKD3moAAAAJ" },
        { timestamp: "36:14", context: "CienciaVitae - Academic profile and affiliations", url: "https://www.cienciavitae.pt/1111-43FF-1F99" },
      ],
      sourceLinks: [
        { timestamp: "03:34", context: "AlphaGo - DeepMind (machine learning)", url: "https://deepmind.google/research/breakthroughs/alphago/" },
        { timestamp: "07:48", context: "EU AI Act - European AI regulation", url: "https://artificialintelligenceact.eu/" },
        { timestamp: "14:20", context: "UAE AI Strategy - National AI strategy of the United Arab Emirates", url: "https://ai.gov.ae/" },
        { timestamp: "26:18", context: "Moral Machine (MIT) - Ethical dilemmas of autonomous vehicles", url: "https://www.moralmachine.net/" },
        { timestamp: "30:34", context: "FEUP - AI course mentioned by the guest", url: "https://sigarra.up.pt/feup/pt/cur_geral.cur_view?pv_curso_id=23521" },
        { timestamp: "37:56", context: "Unitree Robotics - Advanced robotics referenced in the episode", url: "https://www.unitree.com/" },
      ],
    },
    es: {
      title: "The BlackBox",
      titleIsEnglish: true,
      guestBio: "Director del Laboratorio de IA de la UP",
      description:
        "Una exploración sobre la evolución de la inteligencia artificial, desde los sistemas que aprenden por sí mismos hasta los riesgos de seguridad y pérdida de control.\n\nDesde el fraude digital hasta la singularidad, analizamos hasta dónde puede llegar la IA y lo que eso significa para las empresas, la sociedad y el futuro del trabajo y la educación.",
    },
  },
  6: {
    en: {
      title: "When Code Becomes Law",
      guestBio: "Public Policy Specialist",
      description:
        "An analysis of how digital systems are transforming the market, information and individual autonomy.\n\nFrom the influence of Big Tech to Europe's position, we discuss the impact of algorithms on competitiveness, decision-making and economic freedom.",
      summary:
        "In this episode, Pedro Mendes speaks with Ricardo Valente about Artificial Intelligence, smart cities, data sovereignty, digitalization, geopolitics and social transformation. The conversation starts with the relationship between city, information and citizen, reflecting on what it means to be a smart city in a context where data is increasingly important for urban management.\n\nRicardo Valente argues that technology only creates value when it is aligned with strategy, vision and well-structured processes. Digitalization, by itself, does not solve problems: if processes remain poorly designed, technology merely reproduces them in digital form. Ricardo also warns about the tendency for single-answer responses to reduce critical thinking and the fact that AI operates on data whose origin, intent and ownership are not always transparent.\n\nIn the final part, the episode addresses AI as a geopolitical issue, discussing European sovereignty, the AI Act, GDPR and the need for adapting public policies. The episode ends with a central idea: the AI revolution differs from previous ones mainly by its speed, making it harder to keep up, regulate and adapt society to the changes underway.",
      quotes: [
        { timestamp: "07:38", text: "There's no point in digitizing a stupid process. You'll just have a digital stupid." },
        { timestamp: "10:16", text: "We are so close to 1984, to George Orwell and Big Brother." },
        { timestamp: "11:10", text: "We often like being completely wrong based on certainty." },
        { timestamp: "15:49", text: "Our value lies in it. It's proprietary information." },
        { timestamp: "30:21", text: "The big problem with the AI revolution is not that we are having a revolution, it's the speed of the revolution." },
      ],
      bioLinks: [
        { timestamp: "00:45", context: "Profile at the Faculty of Economics, University of Porto", url: "https://sigarra.up.pt/fep/pt/func_geral.formview?p_codigo=235980" },
        { timestamp: "00:45", context: "PBS - Porto Business School", url: "https://www.pbs.up.pt/sobre-nos/corpo-docente/docente/ricardo-valente/" },
      ],
      sourceLinks: [
        { timestamp: "10:16", context: "George Orwell - Nineteen Eighty-Four", url: "https://www.orwellfoundation.com/the-orwell-foundation/orwell/books-by-orwell/nineteen-eighty-four/" },
        { timestamp: "25:32", context: "Palantir - Technological sovereignty and strategic security", url: "https://www.palantir.com/" },
        { timestamp: "27:05", context: "EU AI Act - European Artificial Intelligence regulation", url: "https://artificialintelligenceact.eu/" },
        { timestamp: "27:08", context: "GDPR - Data protection in the European Union", url: "https://commission.europa.eu/law/law-topic/data-protection/data-protection-eu_en" },
      ],
    },
    es: {
      title: "La Algoritmización de la Libertad",
      guestBio: "Especialista en Políticas Públicas",
      description:
        "Un análisis de cómo los sistemas digitales están transformando el mercado, la información y la autonomía individual.\n\nDesde la influencia de las Big Tech hasta la posición de Europa, debatimos el impacto de los algoritmos en la competitividad, la toma de decisiones y la libertad económica.",
    },
  },
};

function normalizeLang(lang) {
  if (SUPPORTED_LANGS.includes(lang)) {
    return lang;
  }

  if (typeof window !== "undefined") {
    const storedLang = window.localStorage.getItem("language");

    if (SUPPORTED_LANGS.includes(storedLang)) {
      return storedLang;
    }
  }

  return "pt";
}

function formatDate(dateStr, lang) {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("/");
  if (lang === "en") {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const monthIndex = parseInt(month, 10) - 1;
    return `${monthNames[monthIndex]} ${parseInt(day, 10)}, ${year}`;
  }
  return dateStr;
}

function getEpisodeContent(episode, lang) {
  const translation = EPISODE_TRANSLATIONS[episode.id]?.[lang];

  if (!translation) {
    return episode;
  }

  return {
    ...episode,
    ...translation,
  };
}

/* ─────────────────────────────────────────────
   ÍCONES SVG INLINE
   ───────────────────────────────────────────── */
const IconYoutube = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const IconSpotify = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
  </svg>
);

const IconApple = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const IconLinkedin = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const IconChevronLeft = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
);

const IconChevronRight = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

const IconMic = () => (
  <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
);

const IconLaptop = () => (
  <svg className="h-4 w-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M2.5 2A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5" />
  </svg>
);

const IconTranslate = () => (
  <svg className="h-4 w-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
    <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
  </svg>
);

const IconExternalLink = ({ className = "h-4 w-4" }) => (
  <svg className={className} viewBox="0 0 20 20" fill="currentColor">
    <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
    <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
  </svg>
);

/* ─────────────────────────────────────────────
   COMPONENTE PRINCIPAL
   ───────────────────────────────────────────── */
export default function Podcast({ lang = "pt" }) {
  const [activeEp, setActiveEp] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryLang = searchParams.get("lang");
  const effectiveLang = SUPPORTED_LANGS.includes(queryLang) ? queryLang : lang;
  const resolvedLang = normalizeLang(effectiveLang);
  const copy = PODCAST_COPY[resolvedLang] || PODCAST_COPY.pt;
  const localizedEpisodes = episodes.map((episode) => getEpisodeContent(episode, resolvedLang));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setIsExpanded(false);
  }, [activeEp]);

  // Reveal on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -5% 0px" }
    );
    const reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => {
      if (!el.classList.contains("reveal-visible")) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const scrollCarousel = (dir) => {
    const next = dir === "next"
      ? Math.min(activeEp + 1, episodes.length - 1)
      : Math.max(activeEp - 1, 0);
    setActiveEp(next);
  };

  const currentEp = localizedEpisodes[activeEp];
  const homeHref = resolvedLang === "en" ? "/en" : resolvedLang === "es" ? "/es" : "/pt";

  return (
    <div className="clk-page min-h-screen overflow-x-hidden bg-[#0a0f1a] font-sans text-white">
      {/* ═══════════ HERO ═══════════ */}
      <section className="relative flex min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-[#060b14] px-4 py-20 text-center sm:px-6 sm:py-0">
        {/* Back arrow */}
        <button
          type="button"
          onClick={() => {
            if (window.history.length > 1) {
              navigate(-1);
              return;
            }

            navigate(homeHref);
          }}
          className="absolute left-5 top-6 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/60 backdrop-blur transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] sm:left-8 sm:top-8"
          aria-label={copy.backLabel}
        >
          <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
          </svg>
        </button>
        {/* Language toggle */}
        <button
          type="button"
          onClick={() => {
            const nextLang = resolvedLang === "pt" ? "en" : "pt";
            window.localStorage.setItem("language", nextLang);
            navigate(`/podcast?lang=${nextLang}`);
            window.location.reload();
          }}
          className="absolute right-5 top-6 z-20 flex h-10 items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 text-xs font-semibold uppercase tracking-wider text-white/60 backdrop-blur transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] sm:right-8 sm:top-8"
          aria-label={resolvedLang === "pt" ? "Switch to English" : "Mudar para Português"}
        >
          <IconTranslate />
          {resolvedLang === "pt" ? "EN" : "PT"}
        </button>
        {/* Background glow effects */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(139,242,238,0.16),transparent_60%)]" />
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full bg-[#8BF2EE]/10 blur-[120px] float-glow" />

        {/* Animated sound wave bars */}
        <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 flex items-end gap-[3px] opacity-[0.07] h-32">
          {Array.from({ length: 48 }).map((_, i) => (
            <div
              key={i}
              className="w-[2px] rounded-full bg-[#38c8ba] wave-bar"
              style={{
                height: `${16 + Math.sin(i * 0.4) * 40 + 20}%`,
                animationDelay: `${i * 0.06}s`,
                animationDuration: `${1 + Math.random() * 0.8}s`,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 w-full max-w-3xl px-2 sm:px-0 reveal" data-reveal="fade-up">
          <div className="pointer-events-none absolute left-1/2 top-0 h-[160px] w-[160px] -translate-x-1/2 rounded-full bg-[#8BF2EE]/28 blur-[60px] sm:h-[220px] sm:w-[220px] sm:blur-[75px] md:h-[280px] md:w-[280px] md:blur-[90px]" />
          <div className="pointer-events-none absolute left-1/2 top-8 h-[120px] w-[260px] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(139,242,238,0.3),rgba(56,200,186,0.14),transparent_72%)] blur-[30px] sm:h-[160px] sm:w-[340px]" />
          <img
            src="/assets/logopodcast.png"
            alt="The Invisible Side"
            className="relative mx-auto mb-6 h-24 w-auto sm:mb-8 sm:h-32 md:h-40 lg:h-48 logo-breathe"
          />
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/70 sm:mt-8 sm:text-base md:text-lg">
            {copy.heroDescription}
          </p>

          {/* Platform links */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <a href={podcastYoutubeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-[#FF0000]/20 bg-[#FF0000]/10 px-4 py-2 text-xs font-medium text-[#FF4444] backdrop-blur transition hover:bg-[#FF0000]/20 sm:px-5 sm:py-2.5 sm:text-sm">
              <IconYoutube /> {copy.youtubeLabel}
            </a>
            <a href={podcastSpotifyUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-[#1DB954]/20 bg-[#1DB954]/10 px-4 py-2 text-xs font-medium text-[#1DB954] backdrop-blur transition hover:bg-[#1DB954]/20 sm:px-5 sm:py-2.5 sm:text-sm">
              <IconSpotify /> {copy.spotifyLabel}
            </a>
            <a href={podcastAppleUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-[#9B59B6]/20 bg-[#9B59B6]/10 px-4 py-2 text-xs font-medium text-[#B07CD8] backdrop-blur transition hover:bg-[#9B59B6]/20 sm:px-5 sm:py-2.5 sm:text-sm">
              <IconApple /> {copy.appleLabel}
            </a>
          </div>

          {/* Coming Soon badge */}
          <div className="mt-6 flex justify-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-red-500/30 bg-red-500/10 px-5 py-2 text-sm font-bold uppercase tracking-widest text-red-400 shadow-[0_0_15px_rgba(239,68,68,0.3)] animate-pulse sm:px-6 sm:py-2.5 sm:text-base">
              <svg className="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-13a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-3.25V5Z" clipRule="evenodd" />
              </svg>
              Coming Soon
            </span>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <button
            type="button"
            onClick={() => document.getElementById("clk-about")?.scrollIntoView({ behavior: "smooth" })}
            className="flex flex-col items-center text-white/40 transition hover:text-[#38c8ba]"
            aria-label={copy.scrollAria}
          >
            <span className="text-[10px] font-semibold uppercase tracking-[0.3em]">{copy.scrollLabel}</span>
            <svg className="mt-2 h-5 w-5 scroll-indicator" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10 2a.75.75 0 0 1 .75.75v12.19l2.72-2.72a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2.75A.75.75 0 0 1 10 2Z" />
            </svg>
          </button>
        </div>
      </section>

      {/* ═══════════ ABOUT ═══════════ */}
      <section id="clk-about" className="relative overflow-hidden bg-[#0d1520] py-16 sm:py-24 md:py-32">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(56,200,186,0.06),transparent_40%)]" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#38c8ba]/20 to-transparent" />
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6">

          {/* ── Desktop: side by side ── */}
          <div className="hidden lg:flex lg:items-start lg:gap-12">
            {/* Left - Info */}
            <div className="reveal flex-[1.1]" data-reveal="fade-right">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#38c8ba]/20 bg-[#38c8ba]/5 px-4 py-1.5">
                <IconMic />
                <span className="text-xs font-semibold uppercase tracking-widest text-[#38c8ba]">{copy.eyebrow}</span>
              </div>
              <h2 className="font-heading text-3xl font-bold leading-tight sm:text-4xl">
                {copy.aboutTitlePrefix}<span className="gradient-text">{copy.aboutTitleHighlight}</span>
              </h2>
              <p className="mt-6 leading-relaxed text-white/70">{copy.aboutParagraph1}</p>
              <p className="mt-4 leading-relaxed text-white/70">{copy.aboutParagraph2}</p>
              <div className="mt-8 flex flex-wrap gap-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-white/70 whitespace-nowrap">
                  <IconTranslate />
                  {copy.localeLabel}
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-white/70 whitespace-nowrap">
                  <IconLaptop />
                  {copy.categoryLabel}
                </span>
              </div>
            </div>

            {/* Right - Host card */}
            <div className="reveal flex-[0.9]" data-reveal="fade-left">
              <div className="relative overflow-hidden rounded-3xl border border-[#38c8ba]/15 bg-gradient-to-br from-[#38c8ba]/[0.08] via-[#0f1825] to-[#0a0f1a] p-8 shadow-[0_32px_80px_rgba(0,0,0,0.4)] hover-lift card-shimmer">
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#38c8ba]/10 blur-[60px]" />
                <div className="relative flex flex-col items-center text-center">
                  <img
                    src="/assets/podcast/Pedro.jpg"
                    alt="Pedro Mendes"
                    className="h-32 w-32 rounded-full object-cover border-[3px] border-[#38c8ba]/50 shadow-[0_0_0_8px_rgba(56,200,186,0.08),0_20px_40px_rgba(0,0,0,0.3)] pulse-ring"
                    style={{ objectPosition: "center 18%" }}
                  />
                  <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.35em] text-[#38c8ba]">{copy.hostCategory}</p>
                  <h3 className="mt-2 font-heading text-2xl font-bold text-white">Pedro Mendes</h3>
                  <p className="mt-1 text-sm font-medium text-[#38c8ba]/80">{copy.hostRole}</p>
                  <div className="mt-5 h-px w-16 bg-gradient-to-r from-transparent via-[#38c8ba]/40 to-transparent" />
                  <p className="mt-5 text-sm leading-relaxed text-white/60">{copy.hostBio}</p>
                  <a
                    href={hostLinkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm font-medium text-white/75 transition hover:border-[#0077b5]/40 hover:text-[#0077b5]"
                  >
                    <IconLinkedin /> {copy.hostLinkedin}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* ── Mobile/Tablet: stacked, centered ── */}
          <div className="lg:hidden">
            {/* About info */}
            <div className="reveal text-center" data-reveal="fade-up">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#38c8ba]/20 bg-[#38c8ba]/5 px-4 py-1.5">
                <IconMic />
                <span className="text-xs font-semibold uppercase tracking-widest text-[#38c8ba]">{copy.eyebrow}</span>
              </div>
              <h2 className="font-heading text-3xl font-bold leading-tight sm:text-4xl">
                {copy.aboutTitlePrefix}<span className="gradient-text">{copy.aboutTitleHighlight}</span>
              </h2>
              <p className="mt-6 leading-relaxed text-white/70">{copy.aboutParagraph1}</p>
              <p className="mt-4 leading-relaxed text-white/70">{copy.aboutParagraph2}</p>
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-white/70 whitespace-nowrap">
                  <IconTranslate />
                  {copy.localeLabel}
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-white/70 whitespace-nowrap">
                  <IconLaptop />
                  {copy.categoryLabel}
                </span>
              </div>
            </div>

            {/* Host card */}
            <div className="reveal mt-10" data-reveal="fade-up">
              <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl border border-[#38c8ba]/15 bg-gradient-to-br from-[#38c8ba]/[0.08] via-[#0f1825] to-[#0a0f1a] p-5 sm:p-8 shadow-[0_32px_80px_rgba(0,0,0,0.4)] hover-lift card-shimmer">
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#38c8ba]/10 blur-[60px]" />
                <div className="relative flex flex-col items-center text-center">
                  <img
                    src="/assets/podcast/Pedro.jpg"
                    alt="Pedro Mendes"
                    className="h-24 w-24 sm:h-32 sm:w-32 rounded-full object-cover border-[3px] border-[#38c8ba]/50 shadow-[0_0_0_8px_rgba(56,200,186,0.08),0_20px_40px_rgba(0,0,0,0.3)] pulse-ring"
                    style={{ objectPosition: "center 18%" }}
                  />
                  <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.35em] text-[#38c8ba]">{copy.hostCategory}</p>
                  <h3 className="mt-2 font-heading text-2xl font-bold text-white">Pedro Mendes</h3>
                  <p className="mt-1 text-sm font-medium text-[#38c8ba]/80">{copy.hostRole}</p>
                  <div className="mt-5 h-px w-16 bg-gradient-to-r from-transparent via-[#38c8ba]/40 to-transparent" />
                  <p className="mt-5 text-sm leading-relaxed text-white/60">{copy.hostBio}</p>
                  <a
                    href={hostLinkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm font-medium text-white/75 transition hover:border-[#0077b5]/40 hover:text-[#0077b5]"
                  >
                    <IconLinkedin /> {copy.hostLinkedin}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* ── Sobre o Videocast + Artigo de Opinião ── */}
          <div className="mt-20 reveal" data-reveal="fade-up">
            <h3 className="font-heading text-2xl font-bold sm:text-3xl">{copy.videoEssayTitle}</h3>
            <div className="mt-6 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-8 backdrop-blur space-y-8 card-shimmer">
              {/* Abstract */}
              <div>
                <div className="border-l-4 border-[#38c8ba] pl-4">
                  <p className="text-sm font-semibold italic text-[#38c8ba]/90">
                    {copy.abstractLabel}
                  </p>
                </div>
                {copy.abstractParagraphs.map((paragraph) => (
                  <p key={paragraph} className="mt-6 leading-relaxed text-white/70">
                    {paragraph}
                  </p>
                ))}
                <div className="mt-6">
                  <a
                    href="https://drive.google.com/file/d/10Vna5iE9VDzC9ksqdLKkKviI_B94spY9/view?usp=share_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm font-medium text-[#38c8ba] transition hover:text-[#5edecf] link-underline"
                  >
                    <IconExternalLink /> {copy.articleLink}
                  </a>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-white/10" />

              {/* Artigo de Opinião */}
              <div>
                <h4 className="font-heading text-xl font-bold sm:text-2xl">{copy.articleTitle}</h4>
                <div className="mt-4 border-l-4 border-[#38c8ba] pl-4">
                  <p className="text-base font-semibold italic text-white/90">
                    {copy.articleQuote}
                  </p>
                </div>
                <div className="mt-6 grid gap-5 sm:grid-cols-2">
                  {copy.articleCards.map((card) => (
                    <div key={card.title}>
                      <p className="text-sm font-bold text-white/90">{card.title}</p>
                      <p className="mt-1 text-sm leading-relaxed text-white/60">{card.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════ EPISÓDIOS - CAROUSEL ═══════════ */}
      <section className="relative overflow-hidden bg-[#0a0f1a] py-16 sm:py-24 md:py-32">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(56,200,186,0.05),transparent_55%)]" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(139,242,238,0.06),transparent_26%)]" />
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6">
          <div className="reveal text-center" data-reveal="fade-up">
            <h2 className="font-heading text-3xl font-bold sm:text-4xl">{copy.episodesTitle}</h2>
            <p className="mt-3 text-white/50">{copy.episodesSubtitle}</p>
          </div>

          {/* Carousel navigation dots */}
          <div className="mt-10 flex items-center justify-center gap-2">
            {episodes.map((ep, i) => (
              <button
                key={ep.id}
                onClick={() => setActiveEp(i)}
                className={`h-2.5 rounded-full transition-all duration-300 ${
                  i === activeEp
                    ? "w-8 bg-[#38c8ba] dot-active"
                    : "w-2.5 bg-white/20 hover:bg-white/40"
                }`}
                aria-label={`${copy.episodeLabel} ${i + 1}`}
              />
            ))}
          </div>

          {/* Episode card */}
          <div
            ref={carouselRef}
            className="mt-8 rounded-2xl sm:rounded-3xl border border-white/10 bg-white/[0.03] p-4 backdrop-blur-sm sm:p-6 md:p-10 ep-transition glow-border-active card-shimmer"
          >
            {/* Header */}
            <div className="flex items-start justify-between gap-3 sm:gap-4">
              <div className="min-w-0">
                <span className="text-xs font-semibold uppercase tracking-widest text-[#38c8ba]/70">
                  {copy.episodeLabel} {String(currentEp.id).padStart(2, "0")}
                </span>
                <h3 className="mt-1 font-heading text-xl font-bold sm:text-2xl md:text-3xl">
                  {currentEp.titleIsEnglish && resolvedLang === "pt" ? (
                    <em>{currentEp.title}</em>
                  ) : (
                    currentEp.title
                  )}
                </h3>
                {currentEp.date && (
                  <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-[#38c8ba]/30 bg-[#38c8ba]/10 px-4 py-1.5">
                    <svg className="h-4 w-4 text-[#38c8ba]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                    <span className="text-sm font-semibold text-[#38c8ba]">{formatDate(currentEp.date, resolvedLang)}</span>
                  </div>
                )}
              </div>
              <div className="flex shrink-0 gap-2">
                <button
                  onClick={() => scrollCarousel("prev")}
                  disabled={activeEp === 0}
                  className="rounded-full border border-white/10 p-1.5 sm:p-2 text-white/60 transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] disabled:opacity-30 disabled:cursor-not-allowed"
                  aria-label={copy.previousEpisode}
                >
                  <IconChevronLeft />
                </button>
                <button
                  onClick={() => scrollCarousel("next")}
                  disabled={activeEp === episodes.length - 1}
                  className="rounded-full border border-white/10 p-1.5 sm:p-2 text-white/60 transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] disabled:opacity-30 disabled:cursor-not-allowed"
                  aria-label={copy.nextEpisode}
                >
                  <IconChevronRight />
                </button>
              </div>
            </div>

            {/* Guest info */}
            <div className="mt-5 sm:mt-6 flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
              <img
                key={currentEp.id}
                src={currentEp.guestPhoto}
                alt={currentEp.guest}
                className="h-16 w-16 rounded-full object-cover border-2 border-[#38c8ba]/30 sm:h-20 sm:w-20 md:h-24 md:w-24"
                style={currentEp.guestPhotoPosition ? { objectPosition: currentEp.guestPhotoPosition } : undefined}
              />
              <div className="min-w-0">
                <p className="text-base font-semibold text-white sm:text-lg">{currentEp.guest}</p>
                <p className="text-sm text-white/50">
                  {currentEp.guestBio}
                  {currentEp.guestInstitutionUrl && (
                    <a
                      href={currentEp.guestInstitutionUrl[resolvedLang] || currentEp.guestInstitutionUrl.pt}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-1.5 inline-flex align-middle text-white/30 transition hover:text-[#38c8ba]"
                      aria-label="Institution website"
                    >
                      <IconExternalLink className="h-3.5 w-3.5" />
                    </a>
                  )}
                </p>
              </div>
              {currentEp.linkedin ? (
                <a
                  href={currentEp.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sm:ml-auto inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-xs font-medium text-white/70 transition hover:border-[#0077b5]/40 hover:text-[#0077b5]"
                >
                  <IconLinkedin /> {copy.hostLinkedin}
                </a>
              ) : null}
            </div>

            {/* Description */}
            <div className="mt-6 space-y-3">
              {currentEp.description.split("\n\n").map((paragraph, i) => (
                <p key={i} className="leading-relaxed text-white/70">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* ── Expand toggle + notes panel ── */}
            {currentEp.summary && (
              <>
                <div className="mt-6 border-t border-white/[0.08]" />
                <button
                  type="button"
                  onClick={() => setIsExpanded((v) => !v)}
                  className="mt-4 flex w-full items-center justify-between gap-3 rounded-xl border border-white/[0.08] bg-white/[0.02] px-4 py-3 text-left text-sm font-medium text-white/55 transition hover:border-[#38c8ba]/25 hover:bg-[#38c8ba]/[0.04] hover:text-[#38c8ba]"
                >
                  <span>{isExpanded ? copy.collapseLabel : copy.expandLabel}</span>
                  <svg
                    className={`h-4 w-4 shrink-0 transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`}
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>

                {/* Expandable notes panel */}
                <div className={`ep-notes-grid ${isExpanded ? "is-open" : ""}`}>
                  <div>
                    <div className="space-y-8 pt-6">

                      {/* Summary */}
                      <div>
                        <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#38c8ba]/50">
                          {copy.notesLabel}
                        </p>
                        {currentEp.summary.split("\n\n").map((para, i) => (
                          <p key={i} className="mt-3 text-sm leading-relaxed text-white/60">
                            {para}
                          </p>
                        ))}
                      </div>

                      {/* Key quotes */}
                      {currentEp.quotes && currentEp.quotes.length > 0 && (
                        <div>
                          <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#38c8ba]/50">
                            {copy.quotesLabel}
                          </p>
                          <div className="space-y-2.5">
                            {currentEp.quotes.map((q, i) => (
                              <div
                                key={i}
                                className="flex items-start gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-3.5 sm:p-4"
                              >
                                <span className="shrink-0 rounded-md border border-[#38c8ba]/20 bg-[#38c8ba]/[0.08] px-2 py-1 font-mono text-[9px] font-bold text-[#38c8ba]/70">
                                  {q.timestamp}
                                </span>
                                <p className="text-sm italic leading-relaxed text-white/70">
                                  "{q.text}"
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Links grid */}
                      {((currentEp.bioLinks && currentEp.bioLinks.length > 0) || (currentEp.sourceLinks && currentEp.sourceLinks.length > 0)) && (
                        <div className="grid gap-6 sm:grid-cols-2">
                          {/* Bio / institutional links */}
                          {currentEp.bioLinks && currentEp.bioLinks.length > 0 && (
                            <div>
                              <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#38c8ba]/50">
                                {copy.bioLinksLabel}
                              </p>
                              <ul className="space-y-1.5">
                                {currentEp.bioLinks.map((link, i) => (
                                  <li key={i}>
                                    <a
                                      href={link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="group flex items-start gap-2.5 rounded-lg px-2 py-2 transition hover:bg-white/[0.03]"
                                    >
                                      <span className="mt-0.5 shrink-0 rounded border border-white/10 bg-white/[0.04] px-1.5 py-0.5 font-mono text-[9px] text-white/35 group-hover:border-[#38c8ba]/20 group-hover:text-[#38c8ba]/50 transition">
                                        {link.timestamp}
                                      </span>
                                      <span className="flex-1 text-xs leading-relaxed text-white/50 transition group-hover:text-white/75">
                                        {link.context}
                                      </span>
                                      <span className="mt-0.5 shrink-0 text-white/20 transition group-hover:text-[#38c8ba]/60">
                                        <IconExternalLink className="h-3.5 w-3.5" />
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {/* Source links */}
                          {currentEp.sourceLinks && currentEp.sourceLinks.length > 0 && (
                            <div>
                              <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#38c8ba]/50">
                                {copy.sourceLinksLabel}
                              </p>
                              <ul className="space-y-1.5">
                                {currentEp.sourceLinks.map((link, i) => (
                                  <li key={i}>
                                    <a
                                      href={link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="group flex items-start gap-2.5 rounded-lg px-2 py-2 transition hover:bg-white/[0.03]"
                                    >
                                      <span className="mt-0.5 shrink-0 rounded border border-white/10 bg-white/[0.04] px-1.5 py-0.5 font-mono text-[9px] text-white/35 group-hover:border-[#38c8ba]/20 group-hover:text-[#38c8ba]/50 transition">
                                        {link.timestamp}
                                      </span>
                                      <span className="flex-1 text-xs leading-relaxed text-white/50 transition group-hover:text-white/75">
                                        {link.context}
                                      </span>
                                      <span className="mt-0.5 shrink-0 text-white/20 transition group-hover:text-[#38c8ba]/60">
                                        <IconExternalLink className="h-3.5 w-3.5" />
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Listen links */}
            <div className="mt-8 flex flex-wrap gap-3">
              {(currentEp.links.youtube || podcastYoutubeUrl) ? (
                <a
                  href={currentEp.links.youtube || podcastYoutubeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-[#FF0000]/10 border border-[#FF0000]/20 px-4 py-2 text-sm font-medium text-[#FF4444] transition hover:bg-[#FF0000]/20"
                >
                  <IconYoutube /> {copy.youtubeLabel}
                </a>
              ) : (
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-medium text-white/35">
                  <IconYoutube /> {copy.youtubeLabel}
                </span>
              )}
              {(currentEp.links.spotify || podcastSpotifyUrl) ? (
                <a
                  href={currentEp.links.spotify || podcastSpotifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-[#1DB954]/10 border border-[#1DB954]/20 px-4 py-2 text-sm font-medium text-[#1DB954] transition hover:bg-[#1DB954]/20"
                >
                  <IconSpotify /> {copy.spotifyLabel}
                </a>
              ) : (
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-medium text-white/35">
                  <IconSpotify /> {copy.spotifyLabel}
                </span>
              )}
              {(currentEp.links.apple || podcastAppleUrl) ? (
                <a
                  href={currentEp.links.apple || podcastAppleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-[#9B59B6]/10 border border-[#9B59B6]/20 px-4 py-2 text-sm font-medium text-[#B07CD8] transition hover:bg-[#9B59B6]/20"
                >
                  <IconApple /> {copy.appleLabel}
                </a>
              ) : (
                <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-medium text-white/35">
                  <IconApple /> {copy.appleLabel}
                </span>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════ TODOS OS EPISÓDIOS (grid) ═══════════ */}
      <section className="relative overflow-hidden bg-[#111827] py-16 sm:py-24 md:py-32">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(56,200,186,0.04),transparent_50%)]" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#38c8ba]/15 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(56,200,186,0.05),transparent_28%)]" />
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6">
          <div className="reveal text-center" data-reveal="fade-up">
            <h2 className="font-heading text-3xl font-bold sm:text-4xl">{copy.allEpisodesTitle}</h2>
          </div>
          <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {localizedEpisodes.map((ep, i) => (
              <button
                key={ep.id}
                onClick={() => {
                  setActiveEp(i);
                  document.getElementById("clk-about")?.scrollIntoView({ behavior: "smooth" });
                  setTimeout(() => {
                    carouselRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                  }, 300);
                }}
                className={`group relative overflow-hidden rounded-2xl border p-5 text-left transition-all duration-300 hover:-translate-y-1 card-shimmer ${
                  "border-white/10 bg-white/[0.02] hover:border-[#38c8ba]/20 hover:bg-white/[0.04]"
                }`}
              >
                <span className="absolute -right-3 -top-3 text-[80px] font-black leading-none text-[#38c8ba] opacity-[0.04] transition-transform duration-500 group-hover:scale-110">
                  {String(ep.id).padStart(2, "0")}
                </span>
                <span className="relative text-xs font-semibold uppercase tracking-widest text-[#38c8ba]/60">
                  {copy.episodeLabel} {String(ep.id).padStart(2, "0")}
                </span>
                <h4 className="relative mt-2 text-base font-semibold leading-snug">
                  {ep.titleIsEnglish && resolvedLang === "pt" ? <em>{ep.title}</em> : ep.title}
                </h4>
                <p className="relative mt-1 text-sm text-white/50">{ep.guest}</p>
                {ep.date && (
                  <p className="relative mt-2 text-sm font-medium text-[#38c8ba]/80">{formatDate(ep.date, resolvedLang)}</p>
                )}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════ FOOTER ═══════════ */}
      <footer className="relative overflow-hidden border-t border-white/10 bg-[#060b14] py-12">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_center,rgba(139,242,238,0.04),transparent_30%)]" />
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6 text-center">
          <p className="text-sm text-white/40">
            © {new Date().getFullYear()} Invisible Cloud · {copy.footerTitle}
          </p>
          <div className="mt-4 flex items-center justify-center gap-4">
            <a href={podcastYoutubeUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-white/40 transition hover:text-white/70">
              <IconYoutube />
            </a>
            <a href={podcastSpotifyUrl} target="_blank" rel="noopener noreferrer" aria-label="Spotify" className="text-white/40 transition hover:text-white/70">
              <IconSpotify />
            </a>
            <a href={podcastAppleUrl} target="_blank" rel="noopener noreferrer" aria-label="Apple Podcasts" className="text-white/40 transition hover:text-white/70">
              <IconApple />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
